import { MatDialog } from '@angular/material/dialog';
import {
  ForwardRequestPopupComponent
} from '../app/shared-module/dialogs/forward-request-popup/forward-request-popup.component';
import { ComponentType } from '@angular/cdk/overlay';
import {
  LeadProcessPopupComponent
} from '../app/shared-module/dialogs/lead-process-popup/lead-process-popup.component';
import {
  PlaceInOrderPopupComponent
} from '../app/shared-module/dialogs/place-in-order-popup/place-in-order-popup.component';
import {
  RejectRequestPopupComponent
} from '../app/shared-module/dialogs/reject-request-popup/reject-request-popup.component';
import {
  UndoAssignmentPopupComponent
} from '../app/shared-module/dialogs/undo-assignment-popup/undo-assignment-popup.component';
import { MatDialogRef } from '@angular/material/dialog';
import { LeadTypePopupComponent } from '../app/shared-module/dialogs/lead-type-popup/lead-type-popup.component';
import {
  CloseRequestPopupComponent
} from '../app/shared-module/dialogs/close-request-popup/close-request-popup.component';
import {
  AppointmentMovePopupComponent
} from '../app/shared-module/dialogs/appointment-move-popup/appointment-move-popup.component';
import { OfferMovePopupComponent } from '../app/shared-module/dialogs/offer-move-popup/offer-move-popup.component';
import {
  OfferSubmitPopupComponent
} from '../app/shared-module/dialogs/offer-submit-popup/offer-submit-popup.component';
import {
  AppointmentCreatePopupComponent
} from '../app/shared-module/dialogs/appointment-create-popup/appointment-create-popup.component';
import {
  LeadReminderPopupComponent
} from '../app/shared-module/dialogs/lead-reminder-popup/lead-reminder-popup.component';
import { EditContactComponent } from '../app/shared-module/dialogs/edit-contact/edit-contact.component';
import { OfferDelayPopupComponent } from '../app/shared-module/dialogs/offer-delay-popup/offer-delay-popup.component';
import { ContactInfoComponent } from '../app/shared-module/dialogs/contact-info-component/contact-info.component';
import { NewRequestComponent } from '../app/shared-module/dialogs/new-request/new-request.component';
import { Router } from '@angular/router';
import { ExternalEmailComponent } from '../app/shared-module/dialogs/external-email/external-email.component';
import { DeleteContactComponent } from '../app/shared-module/dialogs/delete-contact/delete-contact.component';
import { LinkComponent } from '../app/page-modules/contact-details/link/link.component';
import { AttachmentsComponent } from '../app/page-modules/contact-details/attachments/attachments.component';
import { DuplicateCheckComponent } from '../app/shared-module/dialogs/duplicate-check/duplicate-check.component';
import { GeneralErrorComponent } from '../app/shared-module/dialogs/general-error/general-error.component';
import {
  NegotiationCreateComponent
} from '../app/shared-module/dialogs/negotiation-create/negotiation-create.component';
import { MaintenanceModeComponent } from '../app/shared-module/dialogs/maintenance-mode/maintenance-mode.component';
import { NegotiationMoveComponent } from "../app/shared-module/dialogs/negotiation-move/negotiation-move.component";
import { ReopenRequestComponent } from "../app/shared-module/dialogs/reopen-request/reopen-request.component";
import { LeadTakeoverComponent } from "../app/shared-module/dialogs/lead-takeover/lead-takeover.component";
import { ErrorComponent } from '../app/page-modules/contact-details/error/error.component';
import { DeleteConfirmComponent } from '../app/page-modules/contact-details/delete-confirm/delete-confirm.component';
import {
  SendExternalEmailPopupComponent
} from '../app/shared-module/dialogs/send-external-email-popup/send-external-email-popup.component';
import {
  EditLeadDialogData,
  LeadComposerChangesModel,
  LeadData,
  LeadsDataAction,
  LeadsDataContactObject
} from "../models/leads/leads.model";
import { LeadAction } from "../models/action.model";
import {
  LeadMultipleStepByStepComponent
} from "../app/shared-module/dialogs/lead-multiple-step-by-step/lead-multiple-step-by-step.component";
import { GeneralMessageComponent } from '../app/shared-module/dialogs/general-message/general-message.component';
import { TagsComponent } from '../app/page-modules/contact-details/tags/tags.component';
import { EditLeadComponent } from '../app/shared-module/dialogs/edit-lead/edit-lead.component';
import {
  OrderOfferDialogComponent, OrderOfferDialogData
} from '../app/page-modules/contact-details/extended-properties/order-offer-dialog.component';
import {
  InvitePlannerPopupComponent
} from '../app/shared-module/dialogs/invite-planner-popup/invite-planner-popup.component';
import {
  VisitPlannerPopupComponent
} from '../app/shared-module/dialogs/visit-planner-popup/visit-planner-popup.component';
import {
  CompendiumAllowPopupComponent
} from '../app/shared-module/dialogs/compendium-allow-popup/compendium-allow-popup.component';
import {
  CompendiumDenyPopupComponent
} from '../app/shared-module/dialogs/compendium-deny-popup/compendium-deny-popup.component';
import { AlertDialogComponent } from '../app/shared-module/dialogs/alert-dialog/alert-dialog.component';
import { IS_DUPLICATED_LEAD } from '../constants/constants';
import {
  CreateRequestFromComposerDialogComponent
} from '../app/shared-module/dialogs/create-request-from-composer/create-request-from-composer-dialog.component';
import {
  ConsultationCreatePopupComponent
} from '../app/shared-module/dialogs/consultation-create-popup/consultation-create-popup.component';
import {
  LeadBrokerStartComponent
} from '../app/shared-module/dialogs/lead-broker-start/lead-broker-start.component';
import {
  LeadBrokerAbortComponent
} from '../app/shared-module/dialogs/lead-broker-abort/lead-broker-abort.component';
import {
  BrokerAssignConfirmComponent
} from '../app/page-modules/contact-details/broker-assign-confirm/broker-assign-confirm.component';

export class ActionHelper {
  private static editedComponents = new Map<Object, boolean>();

  static initializeOrResetUnsavedChanges( component?: Object ) {
    if ( component ) {
      this.editedComponents.delete(component);
      this.editedComponents.set(component, false);
    } else {
      let last: Object;

      for ( const k of this.editedComponents.keys() ) {
        last = k;
      }

      if ( last ) {
        this.editedComponents.set(last, false);
      }
    }
  }

  static clearUnsavedChanges( component?: Object ) {
    if ( component ) {
      this.editedComponents.delete(component);
    } else {
      this.editedComponents.clear();
    }
  }

  static notifyAboutEdit() {
    let last: Object;

    for ( const k of this.editedComponents.keys() ) {
      last = k;
    }

    if ( last ) {
      this.editedComponents.set(last, true);
    }
  }

  static hasUnsavedChanges( component?: Object ) {
    if ( component ) {
      return this.editedComponents.has(component) && this.editedComponents.get(component);
    }

    for ( const value of this.editedComponents.values() ) {
      if ( value ) {
        return true;
      }
    }

    return false;
  }

  static showAction( actionName: string, dialog: MatDialog, dialogData?: any ): MatDialogRef<any> | null {
    let dialogRef: MatDialogRef<any> = null;
    const sizes: DialogSizes = { width: '546px', height: '90vh' };

    switch ( actionName ) {
      case 'DELETE-CONFIRM':
        dialogRef = this.openDialog(DeleteConfirmComponent, dialog, actionName, dialogData, {
          width: 'min(640px, 90vw)',
        });
        break;
      case 'ALERT-DIALOG':
        dialogRef = this.openDialog(AlertDialogComponent, dialog, actionName, dialogData, {
          width: 'min(640px, 90vw)',
        });
        break;
      case 'ERROR':
        dialogRef = this.openDialog(ErrorComponent, dialog, actionName, dialogData);
        break;
      case 'BROKER-ACCEPT-CONFIRM':
        dialogRef = this.openDialog(BrokerAssignConfirmComponent, dialog, actionName, dialogData, {
          width: 'min(640px, 90vw)',
        });
        break;
      case 'CREATE_REQUEST_FROM_COMPOSER':
        dialogRef = this.openDialog(CreateRequestFromComposerDialogComponent, dialog, actionName, dialogData, {
          width: 'min(792px, 90vw)',
        });
        break;
      case 'LEAD_FORWARD':
        dialogRef = this.openDialog(ForwardRequestPopupComponent, dialog, actionName, dialogData);
        break;
      case 'OFFER_DELAY':
        dialogRef = this.openDialog(OfferDelayPopupComponent, dialog, actionName, dialogData);
        break;
      case 'LEAD_REMINDER':
        dialogRef = this.openDialog(LeadReminderPopupComponent, dialog, actionName, dialogData);
        break;
      case 'LEAD_PROCESS_EXT':
        dialogRef = this.openDialog(LeadProcessPopupComponent, dialog, actionName, { ...dialogData, isExternal: true });
        break;
      case 'PLANNER_INVITE':
        dialogRef = this.openDialog(InvitePlannerPopupComponent, dialog, actionName, {
          ...dialogData,
          isPlanerInviteMove: false
        });
        break;
      case 'PLANNER_INVITE_EXT':
        dialogRef = this.openDialog(InvitePlannerPopupComponent, dialog, actionName, {
          ...dialogData,
          isPlanerInviteMove: false,
          isExternal: true
        });
        break;
      case 'PLANNER_INVITE_MOVE':
        dialogRef = this.openDialog(InvitePlannerPopupComponent, dialog, actionName, {
          ...dialogData,
          isPlanerInviteMove: true
        });
        break;
      case 'PLANNER_VISIT':
        dialogRef = this.openDialog(VisitPlannerPopupComponent, dialog, actionName, {
          ...dialogData,
          isPlanerVisitMove: false
        });
        break;
      case 'PLANNER_VISIT_EXT':
        dialogRef = this.openDialog(VisitPlannerPopupComponent, dialog, actionName, {
          ...dialogData,
          isPlanerVisitMove: false,
          isExternal: true
        });
        break;
      case 'PLANNER_VISIT_MOVE':
        dialogRef = this.openDialog(VisitPlannerPopupComponent, dialog, actionName, {
          ...dialogData,
          isPlanerVisitMove: true
        });
        break;
      case 'LEAD_PROCESS':
        dialogRef = this.openDialog(LeadProcessPopupComponent, dialog, actionName, dialogData);
        break;
      case 'ORDER_PLACED':
        dialogRef = this.openDialog(PlaceInOrderPopupComponent, dialog, actionName, dialogData);
        break;
      case 'ORDER_PLACED_EXTERNAL':
        dialogRef = this.openDialog(PlaceInOrderPopupComponent, dialog, actionName, {
          ...dialogData,
          isExternal: true
        });
        break;
      case 'LEAD_REJECT':
        dialogRef = this.openDialog(RejectRequestPopupComponent, dialog, actionName, dialogData);
        break;
      case 'LEAD_FORWARD_UNDO':
        dialogRef = this.openDialog(UndoAssignmentPopupComponent, dialog, actionName, dialogData);
        break;
      case 'LEAD_FORWARD_EXT':
        dialogRef = this.openDialog(ExternalEmailComponent, dialog, actionName, { ...dialogData, isExternal: true });
        break;
      case 'LEAD_TYPE':
        dialogRef = this.openDialog(LeadTypePopupComponent, dialog, actionName, dialogData);
        break;
      case 'LEAD_NOT_INTERESTED':
        dialogRef = this.openDialog(CloseRequestPopupComponent, dialog, actionName, dialogData);
        break;
      case 'APPOINTMENT_MOVE':
        dialogRef = this.openDialog(AppointmentMovePopupComponent, dialog, actionName, dialogData);
        break;
      case 'OFFER_MOVE':
        dialogRef = this.openDialog(OfferMovePopupComponent, dialog, actionName, dialogData);
        break;
      case 'OFFER_SUBMIT':
        dialogRef = this.openDialog(OfferSubmitPopupComponent, dialog, actionName, dialogData);
        break;
      case 'OFFER_SUBMIT_EXTERNAL':
        dialogRef = this.openDialog(OfferSubmitPopupComponent, dialog, actionName, { ...dialogData, isExternal: true });
        break;
      case 'APPOINTMENT_CREATE':
        dialogRef = this.openDialog(AppointmentCreatePopupComponent, dialog, actionName, dialogData);
        break;
      case 'APPOINTMENT_CREATE_EXTERNAL':
        dialogRef = this.openDialog(AppointmentCreatePopupComponent, dialog, actionName, {
          ...dialogData,
          isExternal: true
        });
        break;
      case 'CONSULTATION_CREATE':
        dialogRef = this.openDialog(ConsultationCreatePopupComponent, dialog, actionName, dialogData);
        break;
      case 'CONSULTATION_CREATE_EXTERNAL':
        dialogRef = this.openDialog(ConsultationCreatePopupComponent, dialog, actionName, {
          ...dialogData,
          isExternal: true
        });
        break;
      case 'EDIT_CONTENT':
        dialogRef = this.openDialog(EditContactComponent, dialog, actionName, dialogData, {
          width: '100%',
          height: '100%',
        });
        break;
      case 'CONTACT_INFO':
        dialogRef = this.openDialog(ContactInfoComponent, dialog, actionName, dialogData, sizes);
        break;
      case 'DELETE-LEAD':
        dialogRef = this.openDialog(DeleteContactComponent, dialog, actionName, dialogData);
        break;
      case 'FI-TAGS':
        dialogRef = this.openDialog(TagsComponent, dialog, actionName, dialogData, {
          width: 'min(640px, 90vw)',
        });
        break;
      case 'FI-LINK':
        dialogRef = this.openDialog(LinkComponent, dialog, actionName, dialogData, {
          width: 'min(640px, 90vw)',
        });
        break;
      case 'FI-ATTACHMENTS':
        dialogRef = this.openDialog(AttachmentsComponent, dialog, actionName, dialogData);
        break;
      case 'DUPLICATE-CHECK':
        dialogRef = this.openDialog(DuplicateCheckComponent, dialog, actionName, dialogData);
        break;
      case 'GENERAL_ERROR':
        dialogRef = this.openDialog(GeneralErrorComponent, dialog, actionName);
        break;
      case 'GENERAL_MESSAGE':
        dialogRef = this.openDialog(GeneralMessageComponent, dialog, actionName, dialogData);
        break;
      case 'NEGOTIATION_CREATE':
        dialogRef = this.openDialog(NegotiationCreateComponent, dialog, actionName, dialogData);
        break;
      case 'MAINTENANCE_MODE':
        dialogRef = this.openDialog(MaintenanceModeComponent, dialog, actionName, dialogData);
        break;
      case 'NEGOTIATION_MOVE':
        dialogRef = this.openDialog(NegotiationMoveComponent, dialog, actionName, dialogData);
        break;
      case 'REOPEN_REQUEST':
        dialogRef = this.openDialog(ReopenRequestComponent, dialog, actionName, dialogData);
        break;
      case 'LEAD_TAKEOVER':
        dialogRef = this.openDialog(LeadTakeoverComponent, dialog, actionName, dialogData);
        break;
      case 'LEAD_BROKER_START':
        dialogRef = this.openDialog(LeadBrokerStartComponent, dialog, actionName, dialogData);
        break;
      case 'LEAD_BROKER_ABORT':
        dialogRef = this.openDialog(LeadBrokerAbortComponent, dialog, actionName, dialogData);
        break;
      case 'LEAD_REOPEN':
        dialogRef = this.openDialog(ReopenRequestComponent, dialog, actionName, dialogData);
        break;
      case 'LEAD_REMINDER_EXT':
        dialogRef = this.openDialog(SendExternalEmailPopupComponent, dialog, actionName, {
          ...dialogData,
          isExternal: true
        });
        break;
      case 'MULTIPLE_LEADS_STEP_BY_STEP':
        dialogRef = this.openDialog(LeadMultipleStepByStepComponent, dialog, actionName, dialogData, {
          width: '600px',
          height: '500px'
        });
        break;
      case 'COMPENDIUM_ALLOW':
        dialogRef = this.openDialog(CompendiumAllowPopupComponent, dialog, actionName, dialogData);
        break;
      case 'COMPENDIUM_DENY':
        dialogRef = this.openDialog(CompendiumDenyPopupComponent, dialog, actionName, dialogData);
        break;
      default:
        break;
    }

    return dialogRef;
  }


  static doAction(
    data: {
      selectedLeadDetails: LeadData,
      loadedLeadComposerOffers: LeadComposerChangesModel[],
      onAction?: any,
    },
    action: LeadsDataAction | LeadAction,
    dialog: MatDialog,
    leads: number[] = [],
    isMany: boolean = false,
  ): MatDialogRef<LeadData> {
    let actionData: object;

    if ( !isMany ) {
      actionData = {
        contactName: data.selectedLeadDetails.Lead.Contact.FirstName + ' ' + data.selectedLeadDetails.Lead.Contact.LastName,
        leadId: data.selectedLeadDetails.Lead.Id,
        leadTypeId: data.selectedLeadDetails.Lead.LeadTypeId,
        // @ts-ignore
        title: action.Label,
        externalEmail: data.selectedLeadDetails?.Lead?.ExternalEmail,
        loadedLeadComposerOffers: data.loadedLeadComposerOffers,
        onAction: data.onAction ?? null,
      };
    } else {
      actionData = {
        contactName: '',
        leadId: null,
        leadTypeId: null,
        // @ts-ignore
        title: leads.length + ' ' + action.Text,
        externalEmail: null,
        // @ts-ignore
        actionName: action.actionName,
        isMany,
        leads
      };
    }

    return ActionHelper.showAction(action.Name, dialog, actionData)
  }

  static openDialog( component: ComponentType<any>, dialog: MatDialog, panelClass: string, dialogData?: any, sizes?: DialogSizes )
    : MatDialogRef<any> {
    return dialog.open(component, {
      disableClose: true,
      closeOnNavigation: false,
      maxWidth: sizes && sizes.width ? sizes.width : '100%',
      width: '100%',
      height: sizes ? '' : '100%',
      maxHeight: sizes && sizes.height ? sizes.height : '100%',
      panelClass,
      data: dialogData || {},
      autoFocus: false
    });
  }

  static openEditLeadDialog( dialog: MatDialog, data: EditLeadDialogData, onUpdate?: ( message ) => any ): void {
    dialog.open(EditLeadComponent, {
      disableClose: true,
      closeOnNavigation: false,
      maxWidth: '100%',
      width: '100%',
      height: '100%',
      panelClass: 'edit-lead-dialog',
      data: data,
    }).afterClosed().subscribe(data => {
      if ( !!data ) {
        onUpdate?.(data);
      }
    });
  }

  static openEditOfferOrder( dialog: MatDialog, data: OrderOfferDialogData ): void {
    dialog.open(OrderOfferDialogComponent, {
      disableClose: true,
      closeOnNavigation: false,
      maxWidth: '100%',
      width: '100%',
      height: '100%',
      panelClass: 'edit-order-offer-dialog',
      data,
    });
  }

  static openNewRequestDialog( dialog: MatDialog, router: Router, existingContact?: LeadsDataContactObject ): void {
    dialog.open(NewRequestComponent, {
      disableClose: true,
      closeOnNavigation: false,
      maxWidth: '100%',
      width: '100%',
      height: '100%',
      panelClass: 'new-request-dialog',
      data: existingContact ? {
        contact: existingContact,
      } : undefined,
    }).afterClosed().subscribe(data => {
      if ( !!data ) {
        if ( existingContact ) {
          const newCallback = () => false;
          const oldCallback = router.routeReuseStrategy.shouldReuseRoute;
          router.routeReuseStrategy.shouldReuseRoute = newCallback;

          setTimeout(() => {
            if ( router.routeReuseStrategy.shouldReuseRoute === newCallback ) {
              router.routeReuseStrategy.shouldReuseRoute = oldCallback;
            }
          }, 200);
        }
        sessionStorage.setItem(IS_DUPLICATED_LEAD, 'false');
        router.navigate(['/details/' + data]);
      }
    });
  }

  static reloadLeadsTable( router: Router ): void {
    const queryParams = router.parseUrl(router.url).queryParams;
    const updatedQueryParams = {
      ...queryParams,
      // tslint:disable-next-line:radix
      update: queryParams.update ? parseInt(queryParams.update) + 1 : 1,
    };
    router.navigate(['/'], { queryParams: updatedQueryParams });
  }
}


interface DialogSizes {
  width?: string;
  height?: string;
}
